<template>
    <form ref="form-reserve" class="bookingformvue" :action="bookingUrl" :method="method" novalidate="novalidate">

        <div class="content-top d-md-flex justify-content-between mb-2">

            <div class="btn-group" role="group" aria-label="return">
                <input class="btn-check" type="radio" checked="checked" v-model="mode" name="return" :id="'radio'+inputId"
                    :value="1">
                <label class="btn btn-sm btn-outline-primary" :true-value="1" :false-value="0"
                    :for="'radio'+inputId">Roundtrip</label>

                <input class="btn-check" type="radio" name="return" v-model="mode" :true-value="1" :false-value="0"
                   :id="'radio2'+inputId" :value="0">
                <label class="btn btn-sm btn-outline-primary" :for="'radio2'+inputId">Oneway</label>
            </div>
            <div class="float-md-start my-2 my-lg-0">
                <a :href="restrictedItemsUrl" class="btn btn-outline-secondary btn-sm">Restricted Items</a>
            </div>

        </div>
        <input name="radioInline" value="3" class="d-none">
        <div class="row g-3">

            <div class="col-md-6 col-lg-3 position-relative">
                <!-- From Field -->
                <div class="form-fs-lg bg-light rounded-3 h-100 pt-4 pb-3 px-3 pe-4 d-flex align-items-center">
                    <FloatingLabel v-model:value="origin" class="flex-fill">
                        <template #label>
                            <span class="ms-1"> <i class="fa fa-location-dot"></i> From</span>
                        </template>
                        <v-select id="from-select" v-model="origin" :options="originList" track-by="code" label="code"
                            :reduce="country => country.code" placeholder=" " class="vs-fluid w-100">                            
                            <template v-slot:option="option">
                                <div class="m-1">
                                    <h5 class="m-0">{{ option.country }} - {{ option.code }}</h5>
                                    <span style="margin: 0 0 10px 0; line-height: 1.1;"><small>{{ option.name }}</small>
                                    </span>
                                </div>

                            </template>
                        </v-select>
                    </FloatingLabel>
                    <input type="hidden" name="origin" :value="origin" />

                </div>
                <div class="btn-flip-icon mt-3 mt-md-0">
                    <button type="button" @click="flip" class="btn bg-white shadow btn-round mb-0">
                        <i class="fa-solid fa-right-left" :class="{ flip: toggleFlip }"></i>
                    </button>
                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <!-- To Field -->
                <div class="form-fs-lg bg-light rounded-3 h-100 pt-4 pb-3 px-3 ps-4 d-flex align-items-center">
                    <FloatingLabel v-model:value="dest" class="flex-fill">
                        <template #label>
                           <i class="fa fa-location-dot"></i>
                            <span class="ms-1">To</span>
                        </template>
                        <v-select id="to-select" name="dest" v-model="dest" :options="destList" track-by="code"
                            label="code" :reduce="country => country.code" placeholder=" " class="vs-fluid w-100"
                            :disabled="!origin">
                            <template v-slot:option="option">
                                <h5 class="m-0"> {{ option.country }} - {{ option.code }}</h5>
                                <span style="margin: 0 0 10px 0; line-height: 1.1;"><small>{{ option.name }}</small></span>
                            </template>
                        </v-select>
                    </FloatingLabel>
                    <input type="hidden" name="dest" :value="dest" />

                </div>
            </div>

            <div class="col-md-6 col-lg-3">
                <!-- Date Range Field -->               
                <input class="d-none" name="depart_date" id="depart_date">
                <input class="d-none" name="return_date" id="return_date">

                <div class="d-flex align-items-center form-fs-lg bg-light rounded-3 h-100 px-2 pt-4 pb-3">
                    
                    <FloatingLabel v-show="mode === 1" v-model:value="flatDates" class="flex-fill">
                        <template #label>
                            <i class="fas fa-calendar-day"></i>                             
                            <span class="ms-1"> Depart - Return</span>                            
                        </template>
                        <input id="date" type="text" v-model="flatDates" class="form-control form-control-lg"
                            placeholder="Select dates" ref="dateInput" />                      
                        
                    </FloatingLabel>
                    <FloatingLabel v-show="mode === 0" label="Depart date" v-model:value="departDate" class="flex-fill">
                        <input id="single_date" type="text" class="form-control form-control-lg" v-model="departDate"
                            placeholder="" ref="dateSingle" />
                     
                    </FloatingLabel>

                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <input class="d-none" type="radio" name="selectedSearchType" value="FLEXIBLE" checked="checked" />
                <input name="passengers" type="hidden" v-model="paxCount" />
                <input name="adult_passengers" type="hidden" v-model="passengers.adults" />
                <input name="child_passengers" type="hidden" v-model="passengers.children" />
                <input name="infant_passengers" type="hidden" v-model="passengers.infants" />

                <div class="d-flex align-items-center form-fs-lg bg-light rouded-3 h-100 px-2 pt-4 pb-3" ref="paxWrapper">
                    <!-- Passengers Field -->
                    <FloatingLabel v-model:value="paxCount" class="flex-fill mt-1">                       
                        <template #label>
                            <i class=" fas fa-user-plus"></i>
                            <span class="ms-1"> Passengers</span>
                        </template>

                        <!-- <input id="passengers" type="text" class="form-control form-control-lg" v-model="passengersLabel"
                         @click="togglePassengerPicker" autocomplete="off"/>  -->
                        <textarea class="form-control form-control-lg" @click="togglePassengerPicker" style="max-height:60px ;padding-top: 0.8rem;"
                         v-model="passengersLabel"></textarea>

                        <transition name="dropdown-fade">
                            <div v-if="showPassengerPicker" class="dropdown-menu px-3 py-2"
                                style="display: block; min-width: 240px;margin-top:10px; box-shadow: 0px 0 0 #e6e6e6, 0px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 0px 0 #e6e6e6, 0 0px 13px rgba(0, 0, 0, 0.08);">
                                <div class="d-flex py-2 mb-1 border-bottom">
                                    <label class="col-md-6 pe-3 ">Adults <br><small
                                            class="text-muted">12+</small></label>
                                    <touch-spin v-model.number="passengers.adults" :min="1" :max="10"></touch-spin>
                                </div>
                                <div class="d-flex py-2 mb-1 border-bottom">
                                    <label class="col-md-6 pe-3 ">Children <br><small class="text-muted">2 - 12 years</small></label>
                                    <touch-spin v-model.number="passengers.children" :min="0" :max="9"></touch-spin>

                                </div>
                                <div class="d-flex py-2 ">
                                    <label class="col-md-6 pe-3 ">Infants <br><small class="text-muted">Under 2 years</small></label>
                                    <touch-spin v-model.number="passengers.infants" :min="0" :max="9"></touch-spin>                                    
                                </div>
                                <div class="d-flex justify-content-between py-3">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearPassengers">Clear</button>
                                    <button type="button" class="btn btn-sm btn-primary" @click="showPassengerPicker =false">Apply</button>
                                </div>

                            </div>
                        </transition>
                    </FloatingLabel>
                    <!-- <div class="form-floating position-relative" ref="paxWrapper">
                         <label for="passengers">Passengers</label>
                    </div> -->
                </div>
            </div>
        </div>
        
        <div class="content-bottom">
            <!-- <a href="#" class="promo-code">+ Add Promo code</a> -->
            <button type="submit" class="btn btn-primary">Find Flights
                <i class="flaticon-flight-1"></i>
            </button>
        </div>

    </form>
</template>

<script setup>
import { ref, watch, useTemplateRef,useId, reactive, computed, onMounted, onBeforeUnmount } from 'vue'


import TouchSpin from "./TouchSpin.vue";
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import FloatingLabel from './FloatingLabel.vue';
import Cookies from 'js-cookie';


import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';

// define props for the raw lists
const props = defineProps({
    originList: { type: Array, required: true },
    destList: { type: Array, required: false },
    actionUrl: { type: String, default: '' },
    method: { type: String, default: 'POST' },
    restrictedItemsUrl:{ type: String, default: '' },
    modelValue: { type: [String, Object, Number], default: null },
    toValue: { type: [String, Object, Number], default: null },
})

// Form state
const origin = computed({
    get() { return props.modelValue },
    set(v) { emit('update:modelValue', v) }
})
const dest = computed({
    get() { return props.toValue },
    set(v) { emit('update:toValue', v) }
});
const COOKIE_NAME = 'last_search'
const COOKIE_EXPIRES_DAYS = 20

const adults = ref(0)
const children = ref(0)
const infants = ref(0)
const showPax = ref(false)
const dateInput = useTemplateRef('dateInput')
const dateSingle = useTemplateRef('dateSingle')
const paxWrapper = ref(null)
const mode = ref(1);
const departDate = ref('')
const inputId = useId();


const emit = defineEmits(['update:modelValue', 'update:toValue'])
// Date range picker

const bookingUrl = computed(() => {
    const params = new URLSearchParams({
        origin: origin.value,
        dest: dest.value,
        return_date: flatDates.value,
        passengers:paxCount,
        selectedSearchType:'FLEXIBLE',
        adult_passengers: passengers.adults,
        child_passengers: passengers.children,
        infant_passenders: passengers.infants
    })
    return `${props.actionUrl}`
    //return `${props.actionUrl}?${params.toString()}`
})


// Passengers picker
const passengers = reactive({ adults: 0, children: 0, infants: 0 })
const showPassengerPicker = ref(false)

const paxCount = computed(() => {
    var num = parseInt(passengers.adults + passengers.children + passengers.infants);
    if(num < 1){
        return null;
    }
    return num;
})


// Computed label
const passengersLabel = computed(() => {
    const parts = []
    if (passengers.adults) parts.push(`${passengers.adults} Adult${passengers.adults > 1 ? 's' : ''}`)
    if (passengers.children) parts.push(`${passengers.children} Child${passengers.children > 1 ? 'ren' : ''}`)
    if (passengers.infants) parts.push(`${passengers.infants} Infant${passengers.infants > 1 ? 's' : ''}`)
   
    return parts.join(', ')
})


// whenever `origin` changes, notify parent so it can recalculate destList
watch(origin, val => {
    console.log(origin);
    if (val) {
        Cookies.set(COOKIE_NAME, val, { expires: COOKIE_EXPIRES_DAYS })
    } else {
        Cookies.remove(COOKIE_NAME)
    }
    emit('update:modelValue', val)
    // parent should listen and update its destList prop accordingly
})
watch(dest, val => emit('update:toValue', val))


const filteredDestinations = computed(() => {
    if (!origin.value) return []
    //return props.destList.map(c => ({...c, disabled: c.code === origin.value }))
    return props.destList.filter(c => c.code !== origin.value)
})

const toggleFlip = ref(false);

function flip(event) {
    console.log(event)
    toggleFlip.value = true;
    setTimeout(() => { toggleFlip.value = false }, 500);
    if (dest.value) {
        let tempOrigin = origin.value;
        origin.value = dest.value;
        dest.value = tempOrigin;
    }

}

function clearPassengers(){
    passengers.adults = 0;
    passengers.infants = 0;
    passengers.children =0;
    togglePassengerPicker();
}
// Toggle passenger picker
function togglePassengerPicker() {
    showPassengerPicker.value = !showPassengerPicker.value
}

function increment(type) {
    passengers[type]++
}
function decrement(type) {
    if (type === 'adults' && passengers.adults <= 1) return
    if (passengers[type] <= 0) return
    passengers[type]--
}

function onClickOutside(e) {
    // if the click target is not inside our paxWrapper, close the menu
    if (paxWrapper.value && !paxWrapper.value.contains(e.target)) {
        showPassengerPicker.value = false
    }
}

const datepickerMode = computed(() => {
    if (mode.value === 1) {
        return 'range';
    } else {
        return 'single';
    }
})

watch(mode, val => {
    // const fp = dateInput.value._flatpickr;  
    // fp.set('mode', datepickerMode);
    // fp.clear();
    // fp.redraw();
})

const flatDates = ref('')
// Initialize flatpickr
onMounted(() => {

    const saved = Cookies.get(COOKIE_NAME)

    if (saved) {
        origin.value = saved
    }

    flatpickr(
        dateInput.value/*document.getElementById('dates')*/, {
        mode: 'range',
        dateFormat: "d M y",
        rangeSeparator: " - ",
        minDate: new Date(),       
        onChange: (selectedDates, dateStr) => {
            flatDates.value = dateStr
        },
        onValueUpdate: function(selectedDates, dateStr, instance) {
            // swap " to " for " - "
            instance._input.value = dateStr.replace(/\s+to\s+/g, " - ");
        },
        onClose: function (selectedDates, dateStr, instance) {
            // console.log(selectedDates);
            if (selectedDates.length > 0) {
                document.querySelectorAll('input[name="return_date"]').forEach(input => {
                    input.value = instance.formatDate(selectedDates[1], 'm/d/Y');
                });
                document.querySelectorAll('input[name="depart_date"]').forEach(input => {
                    input.value = instance.formatDate(selectedDates[0], 'm/d/Y');
                });
            }

        },
        onReady(_, __, instance) {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.textContent = "Clear";
            btn.classList.add("flatpickr-clear-btn");
            btn.classList.add("btn");
             btn.classList.add("flatpickr-clear-btn");
            btn.classList.add("my-1");
            btn.addEventListener("click", () => instance.clear());
            instance.calendarContainer.appendChild(btn);
        },
    });
    if (dateSingle.value) {
        flatpickr(
            dateSingle.value/*document.getElementById('dates')*/, {
            mode: 'single',
            dateFormat: "d M y",
            minDate: new Date(),
            onClose: function (selectedDates, dateStr, instance) {
                // console.log(selectedDates);
                if (selectedDates.length > 0) {
                    document.querySelectorAll('input[name="depart_date"]').forEach(input => {
                        input.value = instance.formatDate(selectedDates[0], 'm/d/Y');
                    });
                }
            },
        });
    }
    document.addEventListener('click', onClickOutside)
})
onBeforeUnmount(() => {
    document.removeEventListener('click', onClickOutside)
})


</script>

<style scoped>


.btn-flip-icon {
    position: absolute;
    left: 100%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

@media only screen and (min-width: 600px) {

    .btn-flip-icon {
        position: absolute;
        left: 50%;
        top: 90%;
    }
}
@media only screen and (max-width: 768px) {
    .btn-flip-icon {
        position: absolute;
        left: 50%;
        top: 90%;
    }

}

@media only screen and (min-width: 992px) {

   .btn-flip-icon {
        position: absolute;
        left: 100%;
        top: 50%;
    }
}

.btn-round {
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 50%;
    padding: 0;
    text-align: center;
}

::v-deep(.flatpickr-clear-btn) {
    user-select: none;
    cursor: pointer;
    align-items: center;
    border: medium none;
    border-radius: 5px;
    touch-action: manipulation;
}

.form-control {
    line-height: 1.1 !important;
}

::v-deep(.flatpickr-calendar .flatpickr-day.selected, .flatpickr-day.startRange) {
    background: #e4520f;
    border-color: #e4520f;
}

::v-deep(.flatpickr-calendar .flatpickr-day.inRange) {
    border-radius: 0;
    -webkit-box-shadow: -5px 0 0 #fb7b40, 5px 0 0 #fb7b40;
    box-shadow: -5px 0 0 #fb7b40, 5px 0 0 #fb7b40;
    color: #f8f9fa;
}

::v-deep(.flatpickr-day:hover, .flatpickr-day:focus) {
    color: white;
}

/* ensure the pax dropdown overlays properly */
.position-relative {
    position: relative;
}

::v-deep(.vs__selected) {
    font-size: 25px;
}

.dropdown-menu {
    border-color: #eee;
}

::v-deep(.vs__dropdown-option--highlight){
    background: #dadada;
    color: #2b2b2b;
}

::v-deep(.vs__dropdown-menu, .vs__dropdown-option) {
    white-space: normal !important;
    word-break: break-word;
    background: white;
    width: 325px !important;
}

::v-deep(.vs__search, .vs__search:focus) {
    line-height: 1.4;
    font-size: 25px !important;
}

/* fade + slide-down effect */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.dropdown-fade-enter-to,
.dropdown-fade-leave-from {
    opacity: 1;
    transform: translateY(0);
}

.bookingformvue .form-control {
    background-color: transparent;
    border: none;
    padding-left: 5px;
    padding-right: 5px;
    box-shadow: none;
}

.flip {
    animation: flip-icon 0.3s ease-in-out;
}

@keyframes flip-icon {
    0% {
        transform: rotateY(180deg);
    }

    100% {
        transform: rotateY(0deg);
    }
}
</style>